import { Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import notfound2 from '../../assets/images/404_4.jpg';
import './style.scss';

const NotFoundPage = () => (
  <>
    <div
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', padding: 8 ,marginTop:"50px"}}
    >
      <img src={notfound2} alt="404" style={{ width: 600, maxWidth: '100%' }} />
      <h1 className="NotF__Content">اوه! هیچی اینجا نیست...</h1>
      <Link to="/">
        <Button className="notfound-button">صفحه اصلی</Button>
      </Link>
    </div>
  </>
);

export default NotFoundPage;
